import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { toastButtonMarginLeftPixels, toastButtonPaddingHorizontalPixels, toastButtonPaddingVerticalPixels, toastLabelMarginLeftPixels, toastLabelPaddingHorizontalPixels, toastLabelPaddingVerticalPixels, } from './constants';
var linkButtonColors = {
    color: tokens.colorNeutralForegroundInverted,
    outlineColor: tokens.colorTransparentStroke,
    ':active': {
        color: tokens.colorNeutralForegroundInverted,
    },
    ':hover': {
        color: tokens.colorNeutralForegroundInverted,
        textDecorationLine: 'underline',
    },
    ':hover:active': {
        color: tokens.colorNeutralForegroundInverted,
    },
    ':focus': {
        color: tokens.colorNeutralForegroundInverted,
        outlineColor: tokens.colorNeutralForegroundInverted,
    },
};
export var useToastElementControlStyles = makeStyles({
    toastElementDiv: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    icon: {
        position: 'relative',
        display: 'flex',
    },
    labelDiv: __assign({ width: '100%', marginLeft: toastLabelMarginLeftPixels }, shorthands.padding(toastLabelPaddingVerticalPixels, toastLabelPaddingHorizontalPixels)),
    toastLabel: {
        color: tokens.colorNeutralForegroundInverted,
        fontFamily: tokens.fontFamilyBase,
        lineHeight: tokens.lineHeightBase300,
        fontSize: tokens.fontSizeBase300, // 14px
    },
    toastButton: __assign(__assign(__assign(__assign({ position: 'relative', display: 'flex', minWidth: 'none', marginLeft: toastButtonMarginLeftPixels }, shorthands.padding(toastButtonPaddingVerticalPixels, toastButtonPaddingHorizontalPixels)), shorthands.borderRadius(tokens.borderRadiusSmall)), { backgroundColor: tokens.colorTransparentBackground, lineHeight: tokens.lineHeightBase200, fontSize: tokens.fontSizeBase200, fontFamily: tokens.fontFamilyBase }), linkButtonColors),
    toastLink: __assign(__assign({}, linkButtonColors), { paddingLeft: '2px' }),
});
//# sourceMappingURL=ToastElementControl.styles.js.map